import LRU from "lru-cache";

export default new LRU<string, HTMLCanvasElement>();
